import { StateSchema } from 'app/config/storeConfig/types';
import { SizeGroupFilter } from '../types';

export const getSelectedSizeGroup = (state: StateSchema): SizeGroupFilter => state.sizeGuideModal.selectedSizeGroup;
